import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BotAvatar from "./BotAvatar";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { colors } from "colors";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import ModeSwitch from "components/users/ModeSwitch";
import { useTheme } from "@emotion/react";
import { fonts } from "fonts";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { MODALS } from "modals";
import { createBotActions } from "store/createBot";
import ModelLabel from "components/model/ModelLabel";
import BotSelectorMenu from "./BotSelectorMenu";

export default function CurrentBotHeader() {

  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const botState = useSelector((state) => state.bot);

  if(botState.loading) {
    return (
      <CircularProgress
        color="secondary"
      />
    );
  }

  if (!botState.current) return null;

  const bot = botState.idMap[botState.current];

  const handleBotAvatarClick = () => {
    dispatch(createBotActions.initializeFromBot(bot));
    dispatch(modalsActions.openModal(MODALS.createEditBotModal))
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <BotAvatar 
        onClick={handleBotAvatarClick}
        botId={bot.id} 
        sx={{
          cursor: "pointer",
        }}
      />
      <Stack>
        <Typography 
          data-testid="bot-header-name"
          fontWeight="bold"
          fontFamily={fonts.anton} 
          color={theme.palette.text.main}
          fontSize={isMobile ? 10 : 18}
        >
          {bot.name}
        </Typography>
        <ModelLabel
          modelId={bot.model}
          variant="caption"
          fontFamily={fonts.geist} 
          color={theme.palette.text.main}
          fontSize={isMobile ? 10 : 12}
        />
      </Stack>
      <BotSelectorMenu />
    </Stack>
  );
}
